/**
 * Desktop chevron step strip: outer ends use rounded corners (≈12px) to match rounded-xl;
 * inner connections keep the chevron clip.
 */
export function getStepStripDesktopRoundedClass(index: number, total: number): string {
  if (index === 0) return "lg:rounded-l-xl lg:rounded-r-none";
  if (index === total - 1) return "lg:rounded-r-xl lg:rounded-l-none";
  return "lg:rounded-none";
}

export function getStepStripDesktopClipClass(index: number, total: number): string {
  if (index === 0) {
    return "[clip-path:polygon(12px_0,calc(100%-16px)_0,100%_50%,calc(100%-16px)_100%,12px_100%,5px_calc(100%-5px),0_calc(100%-12px),0_12px,5px_5px)]";
  }
  if (index === total - 1) {
    return "[clip-path:polygon(0_0,calc(100%-12px)_0,calc(100%-5px)_5px,100%_12px,100%_calc(100%-12px),calc(100%-5px)_calc(100%-5px),calc(100%-12px)_100%,0_100%,16px_50%)]";
  }
  return "[clip-path:polygon(0_0,calc(100%-16px)_0,100%_50%,calc(100%-16px)_100%,0_100%,16px_50%)]";
}

/** Rounded outer ends + chevron clip for desktop step articles */
export function getStepStripDesktopShapeClasses(index: number, total: number): string {
  return `${getStepStripDesktopRoundedClass(index, total)} ${getStepStripDesktopClipClass(index, total)}`;
}
